import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import React, { ReactNode } from 'react';

import { DrawerSectionFooter } from '../drawer-section-footer/DrawerSectionFooter';
import { DrawerSectionHeader } from '../drawer-section-header/DrawerSectionHeader';
import styles from './DrawerSection.module.scss';

interface DrawerSectionProps {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  children: ReactNode;
  headerTitle: ReactNode;
  headerDescription: ReactNode;
  rightHeaderNode?: ReactNode;
  footerLabel?: string;
  footerOnClick?: () => void;
  error: Error | null;
}

/**
 * @deprecated
 */
export const DrawerSection = ({
  isLoading,
  isEmpty,
  isError,
  children,
  headerTitle,
  headerDescription,
  rightHeaderNode,
  footerLabel,
  footerOnClick,
  error,
}: DrawerSectionProps) => {
  if (isLoading) {
    return (
      <SkeletonLoader
        areas={[
          {
            styles: {
              width: '100%',
              height: '248px',
              borderRadius: '8px',
            },
          },
        ]}
      />
    );
  }

  if (isError || isEmpty) {
    throw new Error(error?.message);
  }

  return (
    <div className={styles.root}>
      <DrawerSectionHeader
        title={headerTitle}
        description={headerDescription}
        rightNode={rightHeaderNode}
      />
      {children}
      {!!footerLabel && !!footerOnClick && (
        <DrawerSectionFooter label={footerLabel} onClick={footerOnClick} />
      )}
    </div>
  );
};
